import script from "./HomeNew.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeNew.vue?vue&type=script&setup=true&lang=js"

import "./HomeNew.vue?vue&type=style&index=0&id=7562f38b&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7562f38b"]])

export default __exports__